import { render, staticRenderFns } from "./AuthButtons.vue?vue&type=template&id=b37f6bf8&scoped=true"
import script from "./AuthButtons.vue?vue&type=script&lang=js"
export * from "./AuthButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37f6bf8",
  null
  
)

export default component.exports